module.exports = __webpack_public_path__ + "img/3.f97a1c3d.jpg";